import Vue from "vue";
import { setupCalendar } from "v-calendar";
import { loadLanguageAsync } from "@/helpers/utilities/I18nHelper";

export const setupRolesInVueContext = setup => {
  Vue.prototype.$roles = {};
  Vue.prototype.$roles.isStudent = setup.userProfile.roles.indexOf("Student") !== -1;
  Vue.prototype.$roles.isTeacher = setup.userProfile.roles.indexOf("Teacher") !== -1;
  Vue.prototype.$roles.isSuperUser = setup.userProfile.roles.indexOf("SuperUser") !== -1;
};

export const setupUserContext = setup => {
  Vue.prototype.$skoboUser = {
    userId: setup.userProfile.userId,
    name: setup.userProfile.name,
    extSysApiUserId: setup.userProfile.extSysApiUserId,
    email: setup.userProfile.emailSchoolAddress
  };
};

export const setupApplicationFavicon = setup => {
  const faviconSetup = setup.settings.find(k => k.key === "iconlocationuri");
  try {
    if (faviconSetup) {
      var linksInHead = document.getElementsByTagName("link");

      for (let link of linksInHead) {
        if (link.rel.indexOf("icon") > -1 || link.rel.indexOf("manifest") > -1) {
          link.href = faviconSetup.value + link.href.replace(/(http|https):\/\/.*\/assets\/icons/, "");
        }
      }
    }
    // eslint-disable-next-line no-empty
  } catch {}
};

export const setupLocalization = async setup => {
  let languageSetup = setup.localization.find(k => k.key === "language");

  const languageSetupItem = setup.localization.find(k => k.key === "languagedefault"); // Temporarily move to new language setup. Above line should be removed over time
  if (languageSetupItem) {
    languageSetup = languageSetupItem;
  }

  const languageVariantSetup = setup.localization.find(k => k.key === "languagevariant");
  const customerFileSetup = setup.localization.find(k => k.key === "customerfile");

  await loadLanguageAsync(
    !languageSetup ? "da" : languageSetup.value,
    !languageVariantSetup ? "skole" : languageVariantSetup.value,
    !customerFileSetup ? null : customerFileSetup.value
  );

  const browserLocale = setup.localization.find(k => k.key === "browserlocale");
  Vue.prototype.$browserLocale = !browserLocale ? "da-DK" : browserLocale.value;
};

export const setupVCalendar = setup => {
  const dateFormatSetup = setup.localization.find(k => k.key.toLowerCase() === "dateformat");

  setupCalendar({
    titlePosition: "center",
    masks: {
      title: "MMMM YYYY",
      weekdays: "W",
      navMonths: "MMM",
      dayPopover: "WWWW, " + !dateFormatSetup ? "DD-MM-YYYY" : dateFormatSetup.value,
      input: [dateFormatSetup.value]
    }
  });
};
